import api from "@/api";
import createNewsItem from "./createNewsItem";

export default async ({ url, payload, authJWT, version }) => {
  const response = await api.post({
    url,
    payload,
    authJWT,
    version
  });

  const remoteContent = {};
  const newsItems = response.newsItems.map(newsItem => {
    const mappedNewsItem = createNewsItem(newsItem);
    // RESREFID has been changed to RESIDREF in the BE
    if (mappedNewsItem.remoteContent && mappedNewsItem.remoteContent[0]) {
      // get all the residrefs from the newsItems
      // for now we are not filtering by type as we only have pics
      const { residref } = mappedNewsItem.remoteContent[0];
      remoteContent[residref] = {
        ...mappedNewsItem.remoteContent[0],
        newsItemId: mappedNewsItem.guid
      };
    }
    return mappedNewsItem;
  });

  return { response, remoteContent, newsItems };
};
